import { CarServices } from '@smiles/core-traveler-universe';

import type { IPlaces } from '@smiles/core-traveler-universe/dist/Types/Cars/CarPlaces.types';
import type { CarSearchFilters } from '../../types';
import { Utils } from '../../utils';

export const getSearch = async (searchQuery: string, filterSearchBy: CarSearchFilters): Promise<IPlaces[] | null> => {
  /* if (window.location.hostname === 'localhost') {
    return servicesMocks.core.getSearchMock.data.places;
  } */

  try {
    const { data } = await CarServices.getPlaces({ search: searchQuery, filter: filterSearchBy });

    if (data) {
      return formatPlacesName(data.places);
    }

    return [];
  } catch (err) {
    console.error(err);
    return null;
  }
};

const formatPlacesName = (places: IPlaces[]) => {
  return places.map((place) => {
    const words = place.name.trim().split(', ');
    const capitalizedWords = words
      .map((word) => {
        if (word.length > 2) {
          return Utils.format.capitalizeFirstLetter(word);
        }

        return word;
      })
      .join(', ');

    const formattedWords = capitalizedWords
      .replace(/\s*\[.*?\]\s*/g, '')
      .replace(/\(([^\)]+)\)/g, (_, p1) => `(${p1.toUpperCase()})`);

    return { ...place, name: formattedWords };
  });
};
